import { Layouts } from '~/shared';
// import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledContainer, StyledOverlay } from './Background.styled';

const Background: React.FC = () => {
	return (
		<StyledContainer className={`${Layouts.HomeBuying}-background`}>
			{/* <BgPlaceholder $type={PlaceholderType.HomeBuying} /> */}
			<StyledOverlay />
		</StyledContainer>
	);
};

export { Background };
